import { useTranslation } from 'react-i18next';

export function useGetBudgetsCardLabel(activeBudgetsCount: number) {
  const { t } = useTranslation();

  if (activeBudgetsCount === 0) {
    return t('wallet.pockets.no_active_budgets');
  }

  if (activeBudgetsCount > 1) {
    return t('wallet.pockets.from_budgets', {
      number: activeBudgetsCount,
    });
  }
}
